import { GridActionsCellItem } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';

export const createActionButtons =
  (handleEditClick) =>
  ({ row }) => (
    <GridActionsCellItem
      sx={{
        '&:hover': {
          backgroundColor: 'white',
        },
      }}
      label="Edit"
      icon={
        <Box
          sx={{
            borderRadius: '8px',
            border: '1px solid #ccc',
            padding: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease-in',
            '&:hover': {
              backgroundColor: 'white',
              borderColor: 'green',
              boxShadow: '0px 4px 12px #D0D0D0',
              '& svg': {
                borderColor: 'green',
              },
            },
          }}
        >
          <CreateOutlinedIcon
            sx={{
              color: '#1D1B20',
              '&:hover': {
                borderColor: 'green',
                '& svg': {
                  borderColor: 'green',
                },
              },
            }}
          />
        </Box>
      }
      onClick={handleEditClick(row.id)}
    />
  );
